import {
  ApplicationUser,
  ApplicationUserClient,
  LicenseAppPackage,
  OrganisationClient,
  PaymentClient,
  UserClient,
} from "@src/apis/ModularClient";

export class AssignLicensesController {
  step: number = 4;
  licenseData: LicenseAppPackage;
  totalNoOfLicense: number = 0;
  unassignedLicenses: number = 0;
  load: boolean = false;
  user: ApplicationUser[] = [];
  isUserDisabled: boolean[] = [];
  error: string = "";
  assignLicenseForm: ng.IFormController;
  progressBar: {
    step: number;
    label: string;
    active: boolean;
    complete: boolean;
  }[] = [
    { step: 1, label: "About you", active: false, complete: true },
    { step: 2, label: "About your business", active: false, complete: true },
    {
      step: 3,
      label: "More about your business",
      active: false,
      complete: true,
    },
    { step: 4, label: "Assign licenses", active: false, complete: false },
  ];
  displayMsg: string = "";
  showMsg: boolean = false;
  assignLaterClicked: boolean = false;

  static $inject = ["$location", "PaymentClient", "UserClient", "OrganisationClient"];

  constructor(
    private $location: ng.ILocationService,
    private paymentClient: PaymentClient,
    private userService: UserClient,
    private organisationClient: OrganisationClient,
  ) {
    this.getLicense();
  }
  getLicense() {
    this.paymentClient.getLicense("").then((response) => {
      this.licenseData = response;
      this.totalNoOfLicense = this.licenseData.totalQuantity;
      if (this.totalNoOfLicense - 1 > 0) {
        this.paymentClient.getTotalUnassignedLicenses().then((response) => {
          this.unassignedLicenses = response;
          for (let i = 1; i <= this.unassignedLicenses; i++) {
            var newUser: ApplicationUser = {
              id: null,
            } as ApplicationUser;
            this.user.push(newUser);
            this.isUserDisabled.push(false);
          }
        });
      } else {
        this.progressBar[3].complete = true;
      }

      this.load = true;
    });
  }

  getNumber = function (num) {
    return new Array(num);
  };

  assignLicenses(user: ApplicationUser, index: number) {
    var assignedLicenseusers: ApplicationUser[] = [];
    assignedLicenseusers.push(user);
    this.userService.registerBrokerUsers("", assignedLicenseusers).then((response: string) => {
      if (response.length == 0) {
        this.displayMsg = `Successfully assigned a license to ${assignedLicenseusers[0].firstName} ${assignedLicenseusers[0].lastName}`;
        this.isUserDisabled[index] = true;
        this.showMsg = true;
        this.unassignedLicenses -= 1;
      } else {
        this.displayMsg = response;
        this.showMsg = true;
      }
    });
  }

  goToUserDashboard() {
    this.$location.path("/userdashboard");
  }

  isFormValid() {
    if (this.unassignedLicenses > 0) {
      if (!this.assignLicenseForm.$invalid) {
        this.progressBar[3].complete = true;
        return true;
      } else {
        return false;
      }
    } else {
      this.progressBar[3].complete = true;
      return true;
    }
  }

  assignLater() {
    if (this.unassignedLicenses > 0 && this.assignLaterClicked) {
      this.organisationClient.brokerSignUpJourneyG5Email().then((response) => {
        this.$location.path("/userdashboard");
        this.user = [];
      });
    } else {
      this.$location.path("/userdashboard");
      this.user = [];
    }
  }
}
